import { Game } from './Game';
import { Input } from './Input';
import { bindTouchpad } from './Touchpad.mjs';

export const TouchControls = {
    init() {
        this.arrowsRight = false;
        this.touchpad = false;
        this.resetPads = [];
        try { this.arrowsRight = localStorage.getItem('ladder-touch-arrows') === 'right'; } catch { /* Session-only preference when storage is unavailable. */ }
        try { this.touchpad = localStorage.getItem('ladder-touch-mode') === 'touchpad'; } catch { /* Use buttons by default. */ }
        for (const button of document.querySelectorAll('[data-switch-input]')) {
            button.addEventListener('click', () => {
                this.cancelGestures();
                this.touchpad = !this.touchpad;
                this.renderLayout();
                try { localStorage.setItem('ladder-touch-mode', this.touchpad ? 'touchpad' : 'buttons'); } catch { /* Session-only preference. */ }
            });
        }
        for (const pad of document.querySelectorAll('[data-touchpad]')) {
            this.resetPads.push(bindTouchpad(pad, {
                enabled: () => this.touchpad && this.canPlay(),
                send: code => this.activate(code)
            }));
        }
        window.addEventListener('blur', () => this.cancelGestures());
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.cancelGestures(); });
        for (const button of document.querySelectorAll('[data-switch-controls]')) {
            button.addEventListener('click', () => {
                this.arrowsRight = !this.arrowsRight;
                this.renderLayout();
                try { localStorage.setItem('ladder-touch-arrows', this.arrowsRight ? 'right' : 'left'); } catch { /* Controls still switch without storage. */ }
            });
        }
        this.renderLayout();
        for (const button of document.querySelectorAll('[data-game-key]')) {
            const activate = () => {
                this.activate(button.dataset.gameKey);
            };
            // Trigger on contact, without waiting for touch release. No hold timers:
            // Ladder keeps moving after a direction is selected, just like the keyboard.
            button.addEventListener('pointerdown', event => {
                if (event.button !== 0) return;
                event.preventDefault();
                activate();
            });
            button.addEventListener('click', event => {
                // Screen readers and keyboard activation produce a click without a
                // pointer press. A normal touch click must not enqueue a second jump.
                if (event.detail === 0) activate();
            });
            button.addEventListener('contextmenu', event => event.preventDefault());
        }
    },

    canPlay() {
        return Game.ready && !Game.workshopOpen && !Input.suspended && Game.session && !Game.session.paused && !Game.session.testResult;
    },

    activate(code) {
        if (this.canPlay()) Input.enqueue(code, code === 'Space' ? ' ' : code);
    },

    cancelGestures() { this.resetPads.forEach(reset => reset()); },

    renderLayout() {
        for (const controls of document.querySelectorAll('.touch-controls')) {
            controls.dataset.arrowsSide = this.arrowsRight ? 'right' : 'left';
            controls.querySelector('.direction-pad').hidden = this.touchpad;
            controls.querySelector('.touch-jump').hidden = this.touchpad;
            controls.querySelector('[data-touchpad]').hidden = !this.touchpad;
            controls.querySelector('.touch-help').textContent = this.touchpad ? 'Swipe to move · Tap to jump · Lift and tap after a swipe to jump' : 'Tap arrows to move · Stop in the center · Tap Jump to jump';
        }
        for (const button of document.querySelectorAll('[data-switch-controls]')) {
            button.textContent = this.arrowsRight ? 'Move arrows to left' : 'Move arrows to right';
            button.hidden = this.touchpad;
        }
        for (const button of document.querySelectorAll('[data-switch-input]')) {
            button.textContent = this.touchpad ? 'Use buttons' : 'Use touchpad';
            button.setAttribute('aria-pressed', String(this.touchpad));
        }
    }
};
